/* ============================================================
   ET - ARTICLE RELATED — Swiper for the "You may also be
   interested in" carousel.

   One instance across both breakpoints: three cards in a row with
   arrows on desktop, a fixed-width swipe with a progress pill on
   mobile. Swiper's own `breakpoints` handles the switch, so the
   instance is never torn down and rebuilt mid-resize.

   The slides are snippets/et-blog-card.liquid's own
   <li class="et-blog-grid__item">, so slideClass points Swiper at
   that class rather than the card being forked to carry
   .swiper-slide.
   ============================================================ */

(function () {
  'use strict';

  /* The section emits one script tag per instance; only the first should bind. */
  if (window.etArticleRelatedLoaded) return;
  window.etArticleRelatedLoaded = true;

  var ROOT_SELECTOR = '.et-article-related';
  var SWIPER_SELECTOR = '[data-et-arel-swiper]';

  function qsa(scope, selector) {
    return Array.prototype.slice.call(scope.querySelectorAll(selector));
  }

  /* In the theme editor a section can be injected after the deferred bundle has
     already run, and on a cold first paint the bundle may not have executed
     yet — cover both without assuming an order. */
  function whenSwiperReady(cb) {
    if (window.Swiper) {
      cb();
      return;
    }

    var vendor = document.querySelector('script[src*="et-swiper.min.js"]');
    if (vendor) {
      vendor.addEventListener('load', cb, { once: true });
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      if (window.Swiper) {
        clearInterval(timer);
        cb();
      } else if (++tries > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  function buildOptions(root) {
    var options = {
      /* Mobile card width lives in CSS so it keeps the 267px the design draws
         and the peek of the next card comes out of the 8px gap. Desktop takes
         over at the breakpoint with three equal columns. */
      slidesPerView: 'auto',
      spaceBetween: 8,
      slideClass: 'et-blog-grid__item',
      speed: 450,
      grabCursor: true,
      watchOverflow: true,
      threshold: 4,
      observer: true,
      observeParents: true,
      breakpoints: {
        /* 990, not 750: the stylesheet's fixed 267px card and its 8px gap live in
           the max-width:749px block, so switching Swiper to three-up at 750
           made the card NARROWER as the viewport grew — 223px at 750 against
           267px at 749. The two now change over at the same breakpoint. */
        990: {
          slidesPerView: 3,
          spaceBetween: 24
        }
      }
    };

    var prev = root.querySelector('[data-et-arel-prev]');
    var next = root.querySelector('[data-et-arel-next]');
    if (prev && next) {
      options.navigation = { prevEl: prev, nextEl: next };

      /* Swiper's a11y module REWRITES aria-label on both arrows with its own
         English defaults ("Previous slide" / "Next slide"), throwing away the
         localised labels the section rendered. Its messages are seeded from
         those same labels so a Dutch store keeps Dutch controls. */
      options.a11y = {
        enabled: true,
        prevSlideMessage: prev.getAttribute('aria-label') || 'Previous',
        nextSlideMessage: next.getAttribute('aria-label') || 'Next'
      };
    } else {
      options.a11y = { enabled: true };
    }

    var scrollbar = root.querySelector('[data-et-arel-scrollbar]');
    if (scrollbar) {
      /* Progress pill: the design draws a fixed 48px thumb in a 111px track, so
         the drag size is pinned rather than left on 'auto' (which would size it
         to the visible-slide ratio and shrink as posts are added). */
      options.scrollbar = { el: scrollbar, draggable: true, dragSize: 48, hide: false };
    }

    return options;
  }

  function init(root) {
    if (!root || root.etSwiper) return;

    var el = root.querySelector(SWIPER_SELECTOR);
    if (!el) return;

    whenSwiperReady(function () {
      /* The section can be removed while the vendor bundle is still loading —
         re-check rather than instantiate into a stale state. */
      if (root.etSwiper || !root.isConnected) return;
      root.etSwiper = new window.Swiper(el, buildOptions(root));
    });
  }

  function destroy(root) {
    if (root.etSwiper) {
      root.etSwiper.destroy(true, true);
      root.etSwiper = null;
    }
  }

  /* shopify:section:load hands us the section wrapper, and the schema's
     `class: et-article-related` puts the root class on that very wrapper — so
     the scope itself has to be tested, not only its descendants. */
  function each(scope, fn) {
    var node = scope || document;
    if (node.matches && node.matches(ROOT_SELECTOR)) fn(node);
    qsa(node, ROOT_SELECTOR).forEach(fn);
  }

  function boot(scope) {
    each(scope, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    each(event.target, destroy);
  });
})();
